import Icons from "../../assets/icon";
import { AiOutlineDollarCircle } from "react-icons/ai";
import { GoShareAndroid } from "react-icons/go";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { RiTwitterXLine } from "react-icons/ri";
import { IoClose } from "react-icons/io5";
import {
  Animatespin,
  HoverButton,
  InputField,
  Footer,
  Navbar,
  MainHeading,
  Experience,
} from "../../components/index";
import { FaWhatsapp } from "react-icons/fa";
import Functions from "./index.function";
const JobDetails = () => {
  const {
    singlejob,
    isLoading,
    loadingapi,
    loadingapplyapi,
    isOpen,
    showForm,
    file,
    success,
    user,
    navigate,
    handleToggle,
    handleFileChange,
    clearFile,
    handleSevedJob,
    handleApplyJob,
    openSharePopup,
    setShowForm,
    shareURL,
    control,
    setsuccess,
  } = Functions();
  return (
    <div className="bg-primary relative">
      <Navbar />
      <div className="lg:px-5 xl:px-10 sm:px-5 xs:px-3 m-auto xs:py-5">
        <MainHeading
          title={"Job Details"}
          dis={`Looking for an experienced ${singlejob?.title} for our company.`}
          layout={"h-18 sm:h-20 lg:h-36"}
        />
        {isLoading === true ? (
          <Animatespin />
        ) : (
          <>
            <div className="flex justify-between items-center">
              <div>
                <div className="flex items-center xs:gap-1 sm:gap-1 lg:gap-2 xs:pb-1 sm:pb-1 lg:pb-2">
                  <img
                    className="xs:w-5 sm:w-5 lg:w-6 xl:w-7"
                    src={Icons.jobDetailAgencyIcon}
                    alt=""
                  />
                  <p className="text-goldMetallic font-josefinSansRegular xs:text-base sm:text-base lg:text-xl xl:text-2xl">
                    {singlejob?.company?.name}
                  </p>
                </div>
                <div>
                  <h1 className="text-secondary xs:text-lg sm:text-xl lg:text-2xl xl:text-3xl font-unboundedBold lg:py-1">
                    {singlejob?.title}
                  </h1>
                  <p className="text-secondary font-onestLight xs:text-sm sm:text-sm lg:text-base xl:text-lg">
                    {singlejob?.city?.city}, {singlejob?.country?.country}
                  </p>

                  {singlejob?.hide_salary ? (
                    ""
                  ) : (
                    <div className="flex items-center gap-1">
                      {singlejob?.salary_currency === "$" && (
                        <AiOutlineDollarCircle className="text-secondary xs:text-base sm:text-lg lg:text-xl xl:text-2xl" />
                      )}
                      <p className="text-secondary font-onestRegular xs:text-sm sm:text-sm lg:text-base xl:text-lg">{`${
                        singlejob?.salary_currency ?? ""
                      } ${singlejob?.salary_from} - ${
                        singlejob?.salary_currency ?? ""
                      } ${singlejob?.salary_to}`}</p>
                    </div>
                  )}
                </div>
              </div>
              <button
                className={`group xs:w-10 xs:h-10 sm:w-10 sm:h-10 lg:w-12 lg:h-12 flex justify-center items-center rounded-full transition-all duration-300
                                ${
                                  user?.role === "employer"
                                    ? "cursor-not-allowed"
                                    : "hover:scale-110 cursor-pointer hover:bg-[#333333]"
                                } bg-[#1A1A1A]`}
                onClick={() => {
                  if (user?.role === "fan") {
                    navigate("/upgrade");
                  } else {
                    handleSevedJob(singlejob?.id, singlejob?.is_job_saved);
                  }
                }}
                disabled={user?.role === "employer" ? true : false}
              >
                {loadingapi ? (
                  <div className="flex justify-center items-center">
                    <div className="animate-spin rounded-full border-t-2 border-b-2 group-hover:border-primary border-secondary lg:w-6 lg:h-6 sm:w-4 sm:h-4 xs:w-3 xs:h-3"></div>
                  </div>
                ) : (
                  <img
                    className={`xs:w-4 sm:w-4 lg:w-5 transition-all duration-300 ${
                      user?.role === "talent" ? "group-hover:scale-110" : ""
                    }`}
                    src={
                      singlejob?.is_job_saved
                        ? Icons.dasSavedIcon
                        : Icons.dasSaveIcon
                    }
                    alt={
                      singlejob?.is_job_saved
                        ? Icons.dasSavedIcon
                        : Icons.dasSaveIcon
                    }
                  />
                )}
              </button>
            </div>
            <div className="xs:py-5 sm:pt-3 sm:pb-5 lg:pt-5 lg:pb-0">
              <div className="xs:pt-4 sm:mt-7 lg:mt-10">
                <h3 className="xl:text-xl font-onestMedium xs:text-base sm:text-lg lg:text-xl text-secondary xs:pb-2 sm:pb-3 lg:pb-5">
                  Job Description
                </h3>
                <div
                  className="html-container text-secondary font-onestLight xs:text-sm sm:text-sm lg:text-base"
                  dangerouslySetInnerHTML={{ __html: singlejob?.description }}
                />
              </div>
            </div>
            <div className="xs:py-5 sm:pt-3 sm:pb-5 lg:pt-5 lg:pb-0">
              <div className="xs:pt-4 sm:mt-7 lg:mt-10">
                <h3 className="xl:text-xl font-onestMedium xs:text-base sm:text-lg lg:text-xl text-secondary xs:pb-2 sm:pb-3 lg:pb-5">
                  Benefits
                </h3>
                <div
                  className="html-container text-secondary font-onestLight xs:text-sm sm:text-sm lg:text-base"
                  dangerouslySetInnerHTML={{ __html: singlejob?.benefits }}
                />
              </div>
            </div>
          </>
        )}
        <div className="flex justify-start items-center sm:pt-5 xs:gap-2 sm:gap-2 lg:gap-3 lg:pt-10">
          <HoverButton
            onClick={() => {
              user?.role === "talent"
                ? handleApplyJob(singlejob?.id, user?.talent?.id)
                : navigate("/upgrade");
            }}
            extraClasses={`group xs:w-28 xs:h-8 sm:w-32 sm:h-10 lg:w-48 bg-cover flex lg:h-10 items-center justify-center rounded-full  ${
              loadingapplyapi ||
              user?.role === "employer" ||
              singlejob?.is_job_applied
                ? ""
                : "hover:scale-105 hover:shadow-md transition-transform transform"
            }`}
            BtnTitle={
              loadingapplyapi ? (
                <div className="flex justify-center items-center">
                  <div className="animate-spin rounded-full border-t-2 border-b-2 border-secondary lg:w-7 lg:h-7 sm:w-6 sm:h-6 xs:w-5 xs:h-5"></div>
                </div>
              ) : singlejob?.is_job_applied ? (
                "Applied"
              ) : (
                "Apply Now"
              )
            }
            disabled={
              loadingapplyapi ||
              user?.role === "employer" ||
              singlejob?.is_job_applied
            }
            BtnTitleClasses={`text-secondary font-onestSemiBold xs:text-xs sm:text-sm lg:text-base ${
              loadingapplyapi ||
              user?.role === "employer" ||
              singlejob?.is_job_applied
                ? ""
                : "transition-transform transform group-hover:scale-110 group-hover:text-primary"
            } `}
          />
          <div className="flex items-center xs:gap-2 sm:gap-2 lg:gap-3 relative">
            <div
              className="group bg-[#1A1A1A] xs:w-6 xs:h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8 rounded-full flex justify-center items-center transition-all duration-300 transform hover:scale-110 hover:shadow-lg cursor-pointer"
              onClick={handleToggle}
            >
              <GoShareAndroid className="text-[#6A6A6A] xs:text-lg sm:text-xl lg:text-2xl transition-transform duration-300 group-hover:rotate-[360deg]" />
            </div>
            <p className="text-secondary xs:text-xs sm:text-sm lg:text-base font-onestSemiBold">
              Share this job
            </p>
            {isOpen && (
              <div className="bg-[#171717] xs:p-3 sm:p-4 rounded-xl lg:p-5 absolute xs:top-8 top-12 left-0">
                <div
                  className="flex items-center justify-start xs:gap-2 sm:gap-3 lg:gap-4 xs:pb-2 sm:pb-3 lg:pb-5"
                  onClick={() =>
                    openSharePopup(
                      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                        shareURL
                      )}`
                    )
                  }
                >
                  <div className="bg-[#1877F2] text-secondary rounded-full cursor-pointer xs:w-7 xs:h-7 sm:w-6 sm:h-6 lg:w-8 lg:h-8 xl:w-8 xl:h-8 flex justify-center items-end ransition-all duration-300 transform hover:scale-110">
                    <FaFacebookF className="xs:text-xl sm:text-lg lg:text-2xl xl:text-2xl" />
                  </div>
                  <p className="text-secondary font-onestMedium xs:text-xs sm:text-xs lg:text-sm">
                    Facebook
                  </p>
                </div>
                <div className="flex items-center justify-start xs:gap-2 sm:gap-3 lg:gap-4 xs:pb-2 sm:pb-3 lg:pb-5">
                  <div
                    className="gradient-container text-secondary rounded-full cursor-pointer xs:w-7 xs:h-7 sm:w-6 sm:h-6 lg:w-8 lg:h-8 xl:w-8 xl:h-8 flex justify-center items-center transition-all duration-300 transform hover:scale-110 hover:shadow-lg hover:bg-[#D90000]"
                    onClick={() =>
                      openSharePopup(
                        `https://www.instagram.com/p/create/?text=${encodeURIComponent(
                          shareURL
                        )}`
                      )
                    }
                  >
                    <FaInstagram className="xs:text-base lg:text-xl sm:text-sm xl:text-xl" />
                  </div>
                  <p className="text-secondary font-onestMedium xs:text-xs sm:text-xs lg:text-sm">
                    Instagram
                  </p>
                </div>
                <div className="flex items-center justify-start xs:gap-2 sm:gap-3 lg:gap-4 xs:pb-2 sm:pb-3 lg:pb-5">
                  <div
                    className="bg-primary text-secondary rounded-full cursor-pointer xs:w-7 xs:h-7 sm:w-6 sm:h-6 lg:w-8 lg:h-8 xl:w-8 xl:h-8 flex justify-center items-center transition-all duration-300 transform hover:scale-110 hover:shadow-lg hover:bg-[#0A95D0]"
                    onClick={() =>
                      openSharePopup(
                        `https://twitter.com/intent/tweet?url=${encodeURIComponent(
                          shareURL
                        )}`
                      )
                    }
                  >
                    <RiTwitterXLine className="xs:text-sm sm:text-sm lg:text-lg xl:text-lg" />
                  </div>
                  <p className="text-secondary font-onestMedium xs:text-xs sm:text-xs lg:text-sm">
                    Twitter
                  </p>
                </div>
                <div className="flex items-center justify-start xs:gap-2 sm:gap-3 lg:gap-4 xs:pb-2 sm:pb-3 lg:pb-5">
                  <div
                    className="bg-[#25D366] text-secondary rounded-full cursor-pointer xs:w-7 xs:h-7 sm:w-6 sm:h-6 lg:w-8 lg:h-8 xl:w-8 xl:h-8 flex justify-center items-center transition-all duration-300 transform hover:scale-110 hover:shadow-lg hover:bg-[#20ba5a]"
                    onClick={() =>
                      openSharePopup(
                        `https://api.whatsapp.com/send?text=${encodeURIComponent(
                          shareURL
                        )}`
                      )
                    }
                  >
                    <FaWhatsapp className="xs:text-sm sm:text-sm lg:text-lg xl:text-lg" />
                  </div>
                  <p className="text-secondary font-onestMedium xs:text-xs sm:text-xs lg:text-sm">
                    WhatsApp
                  </p>
                </div>
                <div className="flex items-center justify-start xs:gap-2 sm:gap-3 lg:gap-4">
                  <div
                    className="bg-[#0B69C7] text-secondary rounded-full cursor-pointer xs:w-7 xs:h-7 sm:w-6 sm:h-6 lg:w-8 lg:h-8 xl:w-8 xl:h-8 flex justify-center items-center transition-all duration-300 transform hover:scale-110 hover:shadow-lg hover:bg-[#084D93]"
                    onClick={() =>
                      openSharePopup(
                        `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
                          shareURL
                        )}`
                      )
                    }
                  >
                    <FaLinkedinIn className="xs:text-base sm:text-sm lg:text-lg xl:text-lg" />
                  </div>
                  <p className="text-secondary font-onestMedium xs:text-xs sm:text-xs lg:text-sm">
                    Linkedin
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <Experience />
      <Footer />
      {showForm && (
        <div className="fixed top-0 left-0 w-full h-screen bg-[#0d0d0def] flex justify-center items-center xs:p-5 sm:p-10 lg:p-16 z-40">
          <div className="xs:w-full sm:w-[85%] lg:w-[80%] xl:w-[60%] bg-[#151515] xs:p-5 sm:p-8 lg:p-10 rounded-3xl h-full relative ">
            <div
              className="group flex justify-center items-center xs:w-5 xs:h-5 sm:w-7 sm:h-7 lg:w-8 lg:h-8 absolute -top-1 -right-1 rounded-full bg-goldMetallic cursor-pointer transform transition-transform duration-300 hover:scale-110"
              onClick={() => setShowForm(false)}
            >
              <IoClose className="text-secondary group-hover:text-primary xs:text-lg sm:text-xl lg:text-2xl transform transition-transform duration-300 group-hover:rotate-180" />
            </div>
            <form className="scroll-container h-full lg:px-2">
              <div className="lg:mb-10">
                <h2 className="text-secondary font-unboundedBold lg:text-xl">
                  Apply Job
                </h2>
              </div>
              <div className="relative mt-[18px]">
                <InputField
                  control={control}
                  label="Full Name"
                  type="text"
                  name="fullName"
                  placeholder="Full Name"
                />
              </div>
              <div className="relative mt-[18px]">
                <InputField
                  control={control}
                  label="Email Address"
                  type="text"
                  name="emailAddress"
                  placeholder="Email Address"
                />
              </div>
              <div className="xs:py-2 sm:py-3 lg:py-4">
                <div className="xs:mb-2 xs:pl-8 sm:mb-2 sm:pl-7 lg:mb-5 lg:pl-8">
                  <p className="xs:text-lg lg:text-lg font-josefinSansRegular text-secondary">
                    Upload Cv/Resume
                  </p>
                </div>
                <div
                  className={`bg-[#171717] xs:px-4 rounded-3xl flex ${
                    file
                      ? "justify-center items-start xs:py-4 sm:py-5 sm:px-4 lg:px-10 lg:py-5"
                      : "justify-center items-center xs:py-5 sm:py-6 lg:py-10"
                  } flex-col`}
                >
                  {file ? (
                    <div className="flex w-full justify-between items-center">
                      <div className="flex items-center xs:gap-1 sm:gap-2 lg:gap-2">
                        <div>
                          <img
                            className="sm:w-10 xs:w-8 lg:w-11"
                            src={Icons.pdfIcon}
                            alt=""
                          />
                        </div>
                        <div>
                          <p className="text-[#808080] font-onestRegular xs:text-sm sm:text-sm lg:text-lg">
                            {file.name}
                          </p>
                          <p className="text-[#808080] font-onestLight xs:text-sm sm:text-sm lg:text-lg">
                            {file.size}
                          </p>
                        </div>
                      </div>
                      <div
                        className="group flex justify-center items-center xs:w-5 xs:h-5 sm:w-7 sm:h-7 lg:w-8 lg:h-8 rounded-full bg-[#393939] cursor-pointer transform transition-transform duration-300 hover:scale-110"
                        onClick={clearFile}
                      >
                        <IoClose className="text-secondary xs:text-lg sm:text-xl lg:text-2xl transform transition-transform duration-300 group-hover:rotate-180" />
                      </div>
                    </div>
                  ) : (
                    <>
                      <img src={Icons.cvfileIcon} alt="documentIcon" />
                      <div className="xs:pt-1 lg:pt-3">
                        <label
                          htmlFor="fileUpload"
                          className="font-onestRegular xs:text-sm text-[#808080] cursor-pointer"
                        >
                          Browse File
                        </label>
                        <input
                          id="fileUpload"
                          type="file"
                          accept="application/pdf"
                          onChange={handleFileChange}
                          className="hidden"
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="xs:py-2 sm:py-3 lg:py-4">
                <div className="xs:mb-2 xs:pl-8 sm:mb-2 sm:pl-7 lg:mb-5 lg:pl-8">
                  <p className="xs:text-lg lg:text-lg font-josefinSansRegular text-secondary">
                    Cover Letter Optional
                  </p>
                </div>
                <div className="xs:h-36 sm:h-40 lg:h-40">
                  <textarea
                    className="xs:px-14 xs:text-[15px] mb-1 px-5 bg-[#171717] text-[16px] font-josefinSansRegular w-full py-4 h-full focus:outline-none text-[#808080] focus:bg-primary transition duration-300 delay-100 focus:ring-2 focus:ring-goldMetallic rounded-3xl "
                    name="coverLetter"
                    placeholder="Cover Letter..."
                  />
                </div>
              </div>
              <div className="flex justify-center flex-col items-center my-10 lg:my-8">
                <HoverButton
                  onClick={() => {
                    setsuccess(true);
                    setShowForm(false);
                  }}
                  extraClasses={
                    "group xs:w-56 xs:h-10 sm:w-60 sm:h-12 lg:w-64 cursor-pointer bg-cover flex lg:h-12 text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform hover:scale-105 hover:shadow-md"
                  }
                  BtnTitle="Submit"
                  disabled={false}
                  BtnTitleClasses={
                    "transition-transform transform group-hover:scale-110 group-hover:text-primary"
                  }
                />
              </div>
            </form>
          </div>
        </div>
      )}
      {success && (
        <div className="fixed top-0 left-0 w-full h-screen bg-[#0d0d0def] flex justify-center items-center xs:p-5 sm:p-10 z-40">
          <div className="xs:w-[80%] sm:w-[45%] lg:w-[35%] 2xl:w-[26%] xl:w-1/3 bg-[#151515] xs:p-5 sm:p-8 rounded-3xl h-auto relative ">
            <div
              className="group flex justify-center items-center xs:w-5 xs:h-5 sm:w-7 sm:h-7 lg:w-8 lg:h-8 absolute -top-1 -right-1 rounded-full bg-goldMetallic cursor-pointer transform transition-transform duration-300 hover:scale-110"
              onClick={() => setsuccess(false)}
            >
              <IoClose className="text-secondary group-hover:text-primary xs:text-lg sm:text-xl lg:text-2xl transform transition-transform duration-300 group-hover:rotate-180" />
            </div>
            <div className="flex justify-center items-center flex-col xs:pt-14 sm:pt-16 lg:pt-20 xl:pt-24">
              <div className="text-center lg:pb-7 xl:pb-14">
                <h2 className="text-secondary font-josefinSansMedium xs:pb-2 sm:pb-3 lg:pb-5 xs:text-xl sm:text-2xl lg:text-3xl xl:text-4xl">
                  Congratulations
                </h2>
                <p className="text-secondary font-josefinSansLight xs:text-xs sm:text-xs lg:text-sm xl:text-base">
                  Your Application has been successfully submitted. You can
                  track the progress of your application through the application
                  menu.
                </p>
              </div>
              <div className="flex justify-center items-center my-10 lg:my-8">
                <HoverButton
                  onClick={() => navigate("/applied-application")}
                  extraClasses={
                    "group xs:w-44 xs:h-10 sm:w-48 sm:h-10 xl:w-64 lg:w-52 cursor-pointer bg-cover flex lg:h-12 items-center justify-center rounded-full transition-transform transform hover:scale-105 hover:shadow-md"
                  }
                  BtnTitle="Go To My Application"
                  BtnTitleClasses={
                    "text-secondary font-onestMedium xs:text-sm sm:text-base lg:text-lg xl:text-xl transition-transform transform group-hover:scale-105 group-hover:text-primary"
                  }
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default JobDetails;
